export default __webpack_public_path__ + "static/media/24c-2x.d4371799.png";